module.exports = __webpack_public_path__ + "static/media/reformed-baptist-network-logo.0a242845.png";